import { render, staticRenderFns } from "./ProfileLikes.vue?vue&type=template&id=4c84980e&scoped=true"
import script from "./ProfileLikes.vue?vue&type=script&lang=ts"
export * from "./ProfileLikes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c84980e",
  null
  
)

export default component.exports